import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Styles from "./DashboardRewardReceived.module.css";
import { getRewardReceivedAction } from "../../../../store/actions/dashboard/DashboardActions";
import { useNavigate } from "react-router-dom";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";

const DashRewardReceived = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { total_reward_received, loading, error } = useSelector((state) => state.dashBoardTotalReward);
  useEffect(() => {
    dispatch(getRewardReceivedAction({}, navigate));
  }, [dispatch]);
  if (loading) {
    return (
      <>
        <ShimmerLoader width='30%' height='10%' count={1} />
      </>
    );
  }
  if (!loading && total_reward_received) {
    return (
      <>
        <div className='d-flex align-items-center border-0 px-3'>
          <div className='rounded-circle bg-primary d-flex  align-items-center justify-content-center' style={{ height: "48px", width: "48px" }}>
            <svg width='26' height='25' viewBox='0 0 26 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
              <path d='M2.6 19.7368V22.3684H23.4V19.7368H2.6ZM2.6 5.26316H5.46C5.35167 5.06579 5.28125 4.85746 5.24875 4.63816C5.21625 4.41886 5.2 4.1886 5.2 3.94737C5.2 2.85088 5.57917 1.91886 6.3375 1.15132C7.09583 0.383772 8.01667 0 9.1 0C9.75 0 10.3512 0.169956 10.9037 0.509868C11.4562 0.849781 11.9383 1.27193 12.35 1.77632L13 2.63158L13.65 1.77632C14.04 1.25 14.5167 0.822368 15.08 0.493421C15.6433 0.164474 16.25 0 16.9 0C17.9833 0 18.9042 0.383772 19.6625 1.15132C20.4208 1.91886 20.8 2.85088 20.8 3.94737C20.8 4.1886 20.7837 4.41886 20.7512 4.63816C20.7188 4.85746 20.6483 5.06579 20.54 5.26316H23.4C24.115 5.26316 24.7271 5.52083 25.2362 6.03618C25.7454 6.55153 26 7.17105 26 7.89474V22.3684C26 23.0921 25.7454 23.7116 25.2362 24.227C24.7271 24.7423 24.115 25 23.4 25H2.6C1.885 25 1.27292 24.7423 0.76375 24.227C0.254583 23.7116 0 23.0921 0 22.3684V7.89474C0 7.17105 0.254583 6.55153 0.76375 6.03618C1.27292 5.52083 1.885 5.26316 2.6 5.26316ZM2.6 15.7895H23.4V7.89474H16.77L19.5 11.6447L17.42 13.1579L13 7.10526L8.58 13.1579L6.5 11.6447L9.165 7.89474H2.6V15.7895ZM9.1 5.26316C9.46833 5.26316 9.77708 5.13706 10.0262 4.88487C10.2754 4.63268 10.4 4.32018 10.4 3.94737C10.4 3.57456 10.2754 3.26206 10.0262 3.00987C9.77708 2.75768 9.46833 2.63158 9.1 2.63158C8.73167 2.63158 8.42292 2.75768 8.17375 3.00987C7.92458 3.26206 7.8 3.57456 7.8 3.94737C7.8 4.32018 7.92458 4.63268 8.17375 4.88487C8.42292 5.13706 8.73167 5.26316 9.1 5.26316ZM16.9 5.26316C17.2683 5.26316 17.5771 5.13706 17.8263 4.88487C18.0754 4.63268 18.2 4.32018 18.2 3.94737C18.2 3.57456 18.0754 3.26206 17.8263 3.00987C17.5771 2.75768 17.2683 2.63158 16.9 2.63158C16.5317 2.63158 16.2229 2.75768 15.9737 3.00987C15.7246 3.26206 15.6 3.57456 15.6 3.94737C15.6 4.32018 15.7246 4.63268 15.9737 4.88487C16.2229 5.13706 16.5317 5.26316 16.9 5.26316Z' fill='#F6F6F6' />
            </svg>
          </div>

          <div className={`${Styles.statistics_number} d-block py-3 ps-4 align-items-center justify-content-center`}>
            <p>Reward Received</p>
            <p className='text-primary fs-4'>{total_reward_received?.total_reward_received?.toFixed(2)} gm</p>
          </div>
        </div>
      </>
    );
  }
};

export default DashRewardReceived;
